import React from "react";
import { useTranslation } from "react-i18next";
import Card from "../../../../../components/Card";
import { formatAmount, formatDollarAmount } from "../../../../../utils/methods";

interface StatementKpiSummaryProps {
  commissionTotal: number;
  cleaningTotal: number;
  transactionsTotal: number;
}

const StatementKpiSummary: React.FC<StatementKpiSummaryProps> = ({ commissionTotal, cleaningTotal, transactionsTotal }) => {
  const { t } = useTranslation();

  const grandTotal = commissionTotal + cleaningTotal + transactionsTotal;

  return (
    <div className="mb-6">
      <p className="text-heading fw-semibold mb-2">
        {t('reconciliation.managerStatement.detail.pageTexts.detailsTab.kpi.heading')}
      </p>
      <div className="row g-4">
        <div className="col-md-3">
          <Card
            title={t('reconciliation.managerStatement.detail.pageTexts.detailsTab.kpi.commission')}
            value={formatDollarAmount(formatAmount(commissionTotal.toFixed(2)))}
            description="&nbsp;"
            icon="ri-money-dollar-circle-line ri-26px"
            variant="primary"
            compact
          />
        </div>
        <div className="col-md-3">
          <Card
            title={t('reconciliation.managerStatement.detail.pageTexts.detailsTab.kpi.cleaningMargin')}
            value={formatDollarAmount(formatAmount(cleaningTotal.toFixed(2)))}
            description="&nbsp;"
            icon="ri-brush-line ri-26px"
            variant="success"
            compact
          />
        </div>
        <div className="col-md-3">
          <Card
            title={t('reconciliation.managerStatement.detail.pageTexts.detailsTab.kpi.transactions')}
            value={formatDollarAmount(formatAmount(transactionsTotal.toFixed(2)))}
            description="&nbsp;"
            icon="ri-shopping-cart-line ri-26px"
            variant="warning"
            compact
          />
        </div>
        <div className="col-md-3">
          <Card
            title={t('reconciliation.managerStatement.detail.pageTexts.detailsTab.kpi.grandTotal')}
            value={formatDollarAmount(formatAmount(grandTotal.toFixed(2)))}
            description="&nbsp;"
            icon="ri-stack-line ri-26px"
            variant="primary"
            background
            compact
          />
        </div>
      </div>
    </div>
  );
};

export default StatementKpiSummary;
